import React, { useEffect } from 'react';

import { RouteProp, useIsFocused, useRoute } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';

import { Screen } from '@/components/ScreenComponent';
import { CxtType, addCxtTag, removeCxtTag } from '@/feature/analytics/connextraTag';
import { LobbyList } from '@/feature/lobby/components/LobbyList';
import { PlayerFiltersProvider } from '@/feature/lobby/hooks/use-player-filters';
import { useActiveProductConfig } from '@/hooks/use-active-product';
import { useOneTrust } from '@/hooks/use-one-trust';
import { ROOT_NAVIGATOR_ID } from '@/navigation/container';
import { PickemLobbyStackParamList } from '@/navigation/pickem/types';

import { LobbyDataProvider } from '../hooks/LobbyDataProvider';
import { useOpenPendingEventSheet } from '../hooks/use-open-pending-event-sheet';

export type LobbyStackScreenProp = NativeStackNavigationProp<
    PickemLobbyStackParamList,
    'LobbyScreen',
    typeof ROOT_NAVIGATOR_ID
>;

export const LobbyScreen = () => {
    const route = useRoute<RouteProp<any, 'LobbyScreen'>>();
    const { league } = route.params || {};
    const productConfig = useActiveProductConfig();
    const isFocused = useIsFocused();
    const { enabled: isMaintenanceEnabled } = productConfig?.appMaintenanceConfig?.primary || {};

    useOpenPendingEventSheet();
    useOneTrust();

    useEffect(() => {
        if (isFocused) {
            addCxtTag({ pageType: CxtType.HOMEPAGE });
        } else {
            removeCxtTag();
        }
    }, [isFocused]);

    return !isMaintenanceEnabled ? (
        <Screen edges={['left', 'right']}>
            <PlayerFiltersProvider>
                <LobbyDataProvider>
                    <LobbyList league={league} />
                </LobbyDataProvider>
            </PlayerFiltersProvider>
        </Screen>
    ) : null;
};
